export default __webpack_public_path__ + "static/remix-hover-light-d3fe3efb298dfa23b9533f3d5817c015.png";